export const initialConsultantsState = {
    consultant: {
        id: null,
        gmc_number: null,
        company_name: null,
        surname: null,
        forename: null,
        can_be_sent_letters: false,
        is_rcop_member: false,
        dms_id: null,
        address: null,
        post_code: null,
        phone: null,
        fax: null,
        email: null,
        is_registered: false,
        out_of_hours_contact_name: null,
        out_of_hours_contact_phone: null,
        out_of_hours_contact_fax: null,
        out_of_hours_contact_email: null,
    },
};
const NotificationConsultant = {
    namespaced: true,
    state: {
        consultant: initialConsultantsState.consultant,
        consultantSnapShot: initialConsultantsState.consultant,
        errorMessages: {
            consultant: {
                id: [],
                gmc_number: [],
                company_name: [],
                surname: [],
                forename: [],
                can_be_sent_letters: [],
                is_rcop_member: [],
                dms_id: [],
                address: [],
                post_code: [],
                phone: [],
                fax: [],
                email: [],
                is_registered: [],
                out_of_hours_contact_name: [],
                out_of_hours_contact_phone: [],
                out_of_hours_contact_fax: [],
                out_of_hours_contact_email: [],
            },
        },
        updatedProps: [],
    },
    mutations: {
        SET_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_CONSULTANT(state, data) {
            state.consultant = data;
        },
        SET_CONSULTANT_SNAP_SHOT(state, data) {
            state.consultantSnapShot = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
    },
    actions: {
        loadConsultant({ commit }, data) {
            commit('SET_CONSULTANT', data);
        },
        loadConsultantSnapShot({ commit }, data) {
            commit('SET_CONSULTANT_SNAP_SHOT', data);
        },
        updateProperty({ commit }, data) {
            commit('SET_PROPERTY', data);
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.consultant, fieldErrors.field);

                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'consultant.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default NotificationConsultant;
